import styled from 'styled-components'

const AmpLightBoxAdContainer = styled.div`
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: min-content;
  height: min-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

export default AmpLightBoxAdContainer
